var irreducible = require('./irreducible');

module.exports = irreducible('Any', function () { return true; });



//////////////////
// WEBPACK FOOTER
// ./node_modules/tcomb/lib/Any.js
// module id = 183
// module chunks = 0